export default __webpack_public_path__ + "static/media/schulungen_bg.ae33323a.png";